import React from 'react';
import { connect } from 'react-redux';
import QueryFilterContainer, {
  mapStateToProps,
} from '../components/QueryFilterContainer';
import { cohortFilterWidths } from '../constants';
import CohortFilterOperatorDropdown from './CohortFilterOperatorDropdown';
import QueryFilterOperatorCell from './QueryFilterOperatorCell';

const QueryFilterOperatorTableCell = ({
  code,
  category,
  dictionary,
  clauseUUID,
  filterUUID,
  isEditing,
  exists,
  canRead,
  canEdit,
  queryUUID,
}) => (
  <>
    {!isEditing && (
      <QueryFilterOperatorCell
        category={category}
        code={code}
        queryUUID={queryUUID}
        clauseUUID={clauseUUID}
        filterUUID={filterUUID}
        dictionaryCode={dictionary.code}
        width={cohortFilterWidths.OPERATOR}
      />
    )}
    {isEditing && (
      <QueryFilterContainer
        exists={exists}
        canRead={canRead}
        canEdit={canEdit}
        queryUUID={queryUUID}
        width={cohortFilterWidths.OPERATOR}
      >
        <CohortFilterOperatorDropdown
          category={category}
          code={code}
          queryUUID={queryUUID}
          clauseUUID={clauseUUID}
          filterUUID={filterUUID}
          dictionaryCode={dictionary.code}
        />
      </QueryFilterContainer>
    )}
  </>
);

export default connect(mapStateToProps)(QueryFilterOperatorTableCell);
